import { Box, Card, styled, useTheme } from '@mui/material';
import CompanyInfoModal from 'components/modal/CompanyInfoModal';
import { H3, Small } from 'components/Typography';
import { useState } from 'react';

import FlexRowAlign from 'components/flexbox/FlexRowAlign';
import { useNavigate } from 'react-router-dom';

const CompanyInfoCard = ({
  isTablet,
  isMobile,
  companyName = '한솔농산',
  completionPercentage = 91,
  description = '기업의 세부 정보를 추가 업데이트하면, 더 정확하게 정부지원금, 정책자금이 추천돼요!',
  ...props
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [showCompanyInfoModal, setShowCompanyInfoModal] = useState(false);

  const handleManageClick = () => {
    setShowCompanyInfoModal(true);
  };

  let padding;
  if (window.innerWidth > 1720 && !isTablet) {
    padding = '0px 0px';
  } else {
    padding = isTablet ? '0px 15px' : '0px 0px';
  }

  const StyledCard = styled(Card)(({ theme }) => ({
    width: '100%',
    padding: padding,
    backgroundColor: 'transparent',
    borderRadius: 0,
    border: 'none',
    [theme.breakpoints.down('sm')]: {
      '& > .MuiBox-root': {
        paddingBottom: 0,
      },
    },
  }));

  return (
    <StyledCard
      sx={{
        border: 'none',
        overflow: 'visible',
        ...props.sx,
      }}
    >
      <Box
        sx={{
          width: '100%',
        }}
      >
        {/* Header */}
        <Box
          onClick={handleManageClick}
          sx={{
            backgroundColor: '#fff',
            padding: isMobile ? '18px' : '26px',
            borderRadius: '24px',
            boxShadow: '1px 4px 6px rgba(0, 0, 0, 0.05)',
            cursor: 'pointer',
            transition: 'box-shadow 0.2s ease',
            '&:hover': {
              boxShadow: '1px 4px 12px rgba(0, 0, 0, 0.1)',
            },
          }}
        >
          {/* Title Row */}
          <FlexRowAlign mb={2} justifyContent="space-between" width="100%">
            <FlexRowAlign
              sx={{
                alignItems: isMobile ? 'flex-start' : 'center',
                flex: 1,
                minWidth: 0, // Allow shrinking below content size
                justifyContent: 'flex-start', // Ensure left alignment
              }}
            >
              <Box
                sx={{
                  marginRight: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  ...(isMobile && {
                    alignSelf: 'flex-start',
                    marginTop: '2px', // Small offset to align with text baseline
                  }),
                }}
              >
                <img
                  src="/static/icons/company.svg"
                  alt="Company Icon"
                  width={32}
                  height={32}
                />
              </Box>
              {isMobile ? (
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <H3 sx={{ marginBottom: '4px' }}>내 기업정보</H3>
                  <Box
                    sx={{
                      color: theme.palette.primary.mainBlue,
                      fontSize: '20px',
                      fontWeight: '700',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      maxWidth: '100%',
                      minWidth: 0,
                    }}
                  >
                    {companyName}
                  </Box>
                </Box>
              ) : (
                <H3 sx={{ textAlign: 'left' }}>
                  홍길동님의 기업정보{' '}
                  <span
                    style={{
                      color: theme.palette.primary.mainBlue,
                      fontSize: '26px',
                      fontWeight: '700',
                    }}
                  >
                    {companyName}
                  </span>
                </H3>
              )}
            </FlexRowAlign>
            <Small
              onClick={handleManageClick}
              sx={{
                color: theme.palette.primary.greytxt,
                fontSize: isMobile ? '13px' : '14px',
                fontWeight: '500',
                cursor: 'pointer',
                flexShrink: 0, // Prevent shrinking
                whiteSpace: 'nowrap',
                ...(isMobile && {
                  alignSelf: 'flex-start',
                  marginTop: '2px', // Small offset to align with text baseline
                }),
                '&:hover': {
                  color: theme.palette.primary.mainBlue,
                },
              }}
            >
              관리 &gt;
            </Small>
          </FlexRowAlign>

          {/* Description */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: isMobile ? '8px' : '16px',
              marginBottom: '16px',
              flexWrap: 'wrap',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <Small
                sx={{
                  fontSize: isMobile ? '13px' : '14px',
                  color: theme.palette.primary.greytxt,
                  fontWeight: '500',
                }}
              >
                부서
              </Small>
              <Small
                sx={{
                  fontSize: isMobile ? '13px' : '14px',
                  color: theme.palette.primary.dark, // Dark gray
                  fontWeight: '500',
                }}
              >
                운영
              </Small>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <Small
                sx={{
                  fontSize: isMobile ? '13px' : '14px',
                  color: theme.palette.primary.greytxt,
                  fontWeight: '500',
                }}
              >
                인원
              </Small>
              <Small
                sx={{
                  fontSize: isMobile ? '13px' : '14px',
                  color: theme.palette.primary.dark, // Dark gray
                  fontWeight: '500',
                }}
              >
                43
              </Small>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <Small
                sx={{
                  fontSize: isMobile ? '13px' : '14px',
                  color: theme.palette.primary.greytxt,
                  fontWeight: '500',
                }}
              >
                사업자등록번호
              </Small>
              <Small
                sx={{
                  fontSize: isMobile ? '13px' : '14px',
                  color: theme.palette.primary.dark, // Dark gray
                  fontWeight: '500',
                }}
              >
                123-567-890
              </Small>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Company Info Modal */}
      <CompanyInfoModal
        showModal={showCompanyInfoModal}
        setShowModal={setShowCompanyInfoModal}
      />
    </StyledCard>
  );
};

export default CompanyInfoCard;
